import React from 'react'
import { useNavigate } from 'react-router-dom'
import GardenWorkAssignCard from './GardenWorkAssign'
import { Bar } from 'react-chartjs-2'
import { WorkAssign } from '../../../../../Helper/Data'

export default function GardenWorkAssignManage(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props
    // console.log(YearValue, YearLabel,MonthValue , MonthLabel)

    const navigate = useNavigate()
    const workAssignedNavigate = (name, screenFlag) => {

        if (name === "Deputy Municipal Commissioner (DMC)") {
            navigate(`/WorkAssignedDMCTable?name=${name}&ApiFlag=DMC&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Garden Officer (GO / AGO)") {
            navigate(`/WorkAssignedDMCTable?name=${name}&ApiFlag=GO_AGO&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Garden Assistant (GA)") {
            navigate(`/WorkAssignedDMCTable?name=${name}&ApiFlag=GA&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Garden Superintendent (GS)") {
            navigate(`/WorkAssignedDMCTable?name=${name}&ApiFlag=GS&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Pending") {
            navigate(`/WorkAssignedDMCTable?name=${name}&ApiFlag=WorkAssingPending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Completed") {
            navigate(`/WorkAssignedDMCTable?name=${name}&ApiFlag=WorkAssingCompleted&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        }
    }

    const Targetdata = {
        labels: ['DMC ', 'GS', 'GO/AGO', 'GA',],
        datasets: [
            {
                // label: "Pending",
                fill: true,
                backgroundColor: [
                    "#cc2836",
                    "#cc2836",
                    "#cc2836",
                    "#cc2836"
                ],
                height: [
                    "10em"
                ],
                data: [
                    Countdata && Countdata?.UploadAssignWork_DMC_TotalCount,
                    Countdata && Countdata?.UploadAssignWork_GS_TotalCount,
                    Countdata && Countdata?.UploadAssignWork_GO_AGO_TotalCount,
                    Countdata && Countdata?.UploadAssignWork_GA_TotalCount,
                ]
            },
            // {
            //     label: "Completed",
            //     fill: true,
            //     backgroundColor: [
            //         "#FFB300",
            //         "#FFB300",
            //         "#FFB300",
            //         "#FFB300"
            //     ],
            //     data: [5, 1, 2, 2]
            // },
            // {
            //     label: "Reopen Pending",
            //     fill: true,
            //     backgroundColor: [
            //         "#253150",
            //         "#253150",
            //         "#253150",
            //         "#253150"
            //     ],
            //     data: [4, 5, 6, 3]
            // }

        ],
    };
    return (
        <div className='row m-1 p-0 mx-0'>
            <h5 className=" pt-2 mb-0 ">Garden Work Assigned by Officials</h5>
             <div className='m-0' > <hr className="mt-2"style={{ color: "#a3964e" }}></hr></div>

            <div className="col-12 col-lg-7  ">
                <div className="row ps-lg-1 pb-lg-0 ">

                    <div className="col-12 col-md-6 col-lg-6 ">
                        <GardenWorkAssignCard
                            title="Deputy Municipal Commissioner (DMC)"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/manager.png'
                            count={Countdata.UploadAssignWork_DMC_TotalCount ? Countdata.UploadAssignWork_DMC_TotalCount : '0'}
                            // navLink='/'
                            workAssignedNavigate={workAssignedNavigate}
                        />
                    </div>

                    <div className="col-12 col-md-6 col-lg-6">
                        <GardenWorkAssignCard
                            title="Garden Superintendent (GS)"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/businessman.png'
                            count={Countdata.UploadAssignWork_GS_TotalCount ? Countdata.UploadAssignWork_GS_TotalCount : '0'}
                            // navLink='/'
                            workAssignedNavigate={workAssignedNavigate}
                        />

                    </div>

                    <div className="col-12 col-md-6 col-lg-6">
                        <GardenWorkAssignCard
                            title="Garden Officer (GO / AGO)"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/gardensuperintendent.png'
                            count={Countdata.UploadAssignWork_GO_AGO_TotalCount ? Countdata.UploadAssignWork_GO_AGO_TotalCount : '0'}
                            // navLink='/'
                            workAssignedNavigate={workAssignedNavigate}
                        />

                    </div>
                    <div className="col-12 col-md-6 col-lg-6">
                        <GardenWorkAssignCard
                            title="Garden Assistant (GA)"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/go.png'
                            count={Countdata.UploadAssignWork_GA_TotalCount ? Countdata.UploadAssignWork_GA_TotalCount : '0'}
                            // navLink='/'
                            workAssignedNavigate={workAssignedNavigate}
                        />

                    </div>


                </div>
            </div>

            <div className="col-12 col-lg-5 pe-3 ">
                <div className="px-5 pt-lg-5 upload_chart Chartborder">
                    <div className="row d-flex justify-content-center align-items-center ">
                        {
                            (Countdata?.UploadAssignWork_DMC_TotalCount != 0) || (Countdata?.UploadAssignWork_GS_TotalCount != 0) ||
                                (Countdata?.UploadAssignWork_GO_AGO_TotalCount != 0) || (Countdata?.UploadAssignWork_GA_TotalCount != 0) ?
                                <Bar
                                    options={WorkAssign}
                                    data={Targetdata}
                                />
                                :
                                <div className='text-danger text-center pt-lg-5 fw-bolder' style={{ height: '28vh' }}>
                                    <img
                                        className='wwork_img pr-1 mt-n3'
                                        src="../assets/img/bar-graph.png"
                                    />
                                    No Data Found
                                </div>
                        }
                    </div>

                </div>
            </div>
        </div>
    )

}

